import './Wrapper.scss'
import React from 'react'
import classnames from 'classnames'

// have i gone too far? yes, yes i have.
const Wrapper = ({ children, className }) => {
  return (
    <div className={classnames('Wrapper', className)}>
      {children}
    </div>
  )
}

Wrapper.displayName = 'Wrapper'

export default Wrapper



// WEBPACK FOOTER //
// ./src/lib/Wrapper.js